export default "__VITE_ASSET__Dih5h$nk__"